import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PriceListAdditionalInfo } from '../../models/pricelist-additional-info.model';

@Component({
  selector: 'lx-additional-info',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './additional-info.component.html',
  styleUrls: ['./additional-info.component.scss', './print-additional-info.component.scss'],
})
export class AdditionalInfoComponent {
  @Input() additionalInformation: PriceListAdditionalInfo[] | undefined;
}
